import React, { useEffect, useState } from 'react';
import { Paper, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actions from './store/colliActions';
import MoveColliDelete from './MoveColliDelete'
import { BackButton, hasPermission } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const ColliDelete = props => {
    let { classes, onBulkDeleteCollis, handleCloseDanger, permissions, location, translations, activeWarehouseID, handleCloseSafe, activeCustomerID, onFetchCollis } = props;
    const [colliList, setColliList] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            let data = []
            if (colliList.length === 0) {
                data = await onFetchCollis({ ActiveCustomerID: activeCustomerID, q: { WarehouseID: activeWarehouseID } });
                setColliList(data)
            }
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <div id="form-dialog-title">{translations['bulk_delete'] || 'Bulk delete'} {translations['collies'] || 'Collies'}  </div>
            <p>{translations['you_want_to_delete'] || 'If you want to delete an Colli , you must move the products to a different colii'}</p>
            { hasPermission(permissions, "colli_delete") && colliList.length !== 0 && colliList.length !== location.state.ColliID.length ? (
                <MoveColliDelete activeCustomerID={activeCustomerID} onBulkDeleteCollis={onBulkDeleteCollis} deleteColli={location.state.ColliID} handleCloseSafe={handleCloseSafe} handleCloseDanger={handleCloseDanger} translations={translations} colliList={colliList} />
            ) : null}
        </Paper>
    );
}

const mapStateToProps = state => {
    return {
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchCollis: (params) => dispatch(actions.fetchCollies(params)),
        onBulkDeleteCollis: colli => dispatch(actions.bulkDeleteCollies(colli)),

    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(ColliDelete));
